export default () => ({
  poiList: [],
});
